export type Environment = 'local' | 'dev' | 'prod'

export type EnvConfig = {
  appUrl: string
  authSettingsUrl: string
}

const configs: Record<Environment, EnvConfig> = {
  local: {
    appUrl: 'https://localhost:1234',
    authSettingsUrl: 'http://localhost:3000/settings',
  },
  dev: {
    appUrl: 'https://dev-presentation.academicwork.com',
    authSettingsUrl: 'https://dev-account.academicwork.com/settings',
  },
  prod: {
    appUrl: 'https://presentation.academicwork.com',
    authSettingsUrl: 'https://account.academicwork.com/settings',
  },
}

export const getEnvConfig = (environment: string): EnvConfig =>
  configs[environment as Environment] ?? configs.prod
